import { fechaHora } from "@/components/contratos/constants";

export const MensajesPortal = ({ mensajes }) => (
  <ol className="relative border-l-2 border-[#00B4CC]/30 ml-2 space-y-4">
    {mensajes.map((m) => (
      <li key={m.id} className="ml-5" data-testid={`portal-mensaje-${m.id}`}>
        <span className="absolute -left-[7px] mt-1.5 w-3 h-3 rounded-full bg-[#00B4CC] ring-4 ring-[#F4F7FA]" />
        <div className="rounded-2xl bg-white border border-slate-200 px-4 py-3">
          <p className="text-sm text-slate-700 whitespace-pre-line break-words">{m.texto}</p>
          <p className="text-[11px] text-slate-400 mt-1.5">{m.autor ? `${m.autor} · ` : ""}{fechaHora(m.created_at)}</p>
        </div>
      </li>
    ))}
  </ol>
);
